namespace RioERP.Orders {
    export interface OrdersRow {
        Id?: number;
        CustomerId?: number;
        OrderNumber?: string;
        CustomerName1?: string;
        CustomerEmail1?: string;
        CustomerEmail2?: string;
        CustomerMobile11?: string;
        CustomerMobile21?: string;
        BillingAddress1?: string;
        BillingAddress2?: string;
        BillingCity?: string;
        BillingCountry?: string;
        BillingStateId?: number;
        BillingPincode?: number;
        ShippingToName?: string;
        ShippingAddress1?: string;
        ShippingAddress2?: string;
        ShippingCity?: string;
        ShippingCountry?: string;
        ShippingStateId?: number;
        ShippingPincode?: number;
        EOrderStatus?: Web.Enums.OrderStatus;
        EShippingType?: Web.Enums.ShippingType;
        DiscountPer?: number;
        CurrencyAmount?: number;
        OrderDate?: string;
        ESourceType?: Web.Enums.SourceType;
        Mode?: number;
        Level?: number;
        Note?: string;
        CurrencyId?: number;
        CalculationCurrency?: number;
        SourceName?: string;
        EmailSendCount?: number;
        IsEmailSent?: boolean;
        EPaymentStatus?: Web.Enums.PaymentStatus;
        LastEmailSentDate?: string;
        FranchiseeId?: number;
        EOrderProcessBy?: Web.Enums.ShippingProviderType;
        DiscountCoupon?: string;
        DiscountAmount?: number;
        GrossAmount?: number;
        NetAmount?: number;
        NetAmountAfterFrDiscount?: number;
        TaxableAmount?: number;
        TaxAmount?: number;
        EShippingStatus?: Web.Enums.ShippingStatus;
        EInvoiceStatus?: RioErp.Web.Enums.InvoiceStatus;
        MailId?: number;
        EPaymentType?: RioErp.Web.Enums.PaymentType;
        Gstin?: string;
        ExpectedShippingDate?: string;
        EInvoiceTo?: Web.Enums.InvoiceTo;
        EFranchiseeDiscountType?: Web.Enums.FranchiseeDiscountType;
        EFranchiseeDiscount?: Web.Enums.FranchiseeDiscount;
        FranchiseeDiscountValue?: number;
        FranchiseeDiscountAmount?: number;
        InvoiceCompanyId?: number;
        ShippingNote?: string;
        SourceOrderNumber?: string;
        IsActive?: boolean;
        FreezeData?: boolean;
        VendorId?: number;
        ShippingProviderId?: number;
        ShippingProviderName?: string;
        CustomerDisplayName?: string;
        CustomerIsActive?: boolean;
        CustomerInsertUserId?: number;
        CustomerInsertDate?: string;
        CustomerUpdateUserId?: number;
        CustomerUpdateDate?: string;
        CustomerECustomerType?: number;
        CustomerGstin?: string;
        CustomerCouponCode?: string;
        OrderProducts?: OrderProductsRow[];
        OrderInstallments?: OrderInstallmentsRow[];
        WebsiteOrderProducts?: WebsiteOrderProductsRow[];
        BillingStateName?: string;
        BillingStateIsActive?: boolean;
        BillingStateInsertUserId?: number;
        BillingStateInsertDate?: string;
        BillingStateUpdateUserId?: number;
        BillingStateUpdateDate?: string;
        BillingStateIsHomeState?: boolean;
        ShippingStateName?: string;
        ShippingStateIsActive?: boolean;
        ShippingStateInsertUserId?: number;
        ShippingStateInsertDate?: string;
        ShippingStateUpdateUserId?: number;
        ShippingStateUpdateDate?: string;
        ShippingStateIsHomeState?: boolean;
        FranchiseeName?: string;
        FranchiseeDescription?: string;
        FranchiseeEmail?: string;
        FranchiseeAlternateEmail?: string;
        FranchiseeMobile?: string;
        FranchiseeAlternateMobile?: string;
        FranchiseeAddress?: string;
        FranchiseeCity?: string;
        FranchiseeStateId?: number;
        FranchiseeUserId?: number;
        FranchiseeGstin?: string;
        FranchiseePan?: string;
        FranchiseeGstCertificate?: string;
        FranchiseeBankName?: string;
        FranchiseeBankAccountType?: number;
        FranchiseeBankAccountName?: string;
        FranchiseeBankAccountNo?: string;
        FranchiseeBankIfscCode?: string;
        FranchiseePincode?: number;
        FranchiseeIsActive?: boolean;
        FranchiseeInsertUserId?: number;
        FranchiseeInsertDate?: string;
        FranchiseeUpdateUserId?: number;
        FranchiseeUpdateDate?: string;
        FranchiseeIsCustomer?: boolean;
        FranchiseeCustomerId?: number;
        FranchiseeDiscountCoupon?: string;
        FranchiseeIsPostPayAllowed?: boolean;
        InvoiceCompanyName?: string;
        InvoiceCompanyAddress?: string;
        InvoiceCompanyGstIn?: string;
        InvoiceCompanyInvoiceCode?: string;
        InvoiceCompanyIsTaxApplicable?: boolean;
        InvoiceCompanyInvoiceChangeDate?: string;
        InvoiceCompanyIsDefault?: boolean;
        InvoiceCompanyFooterNote?: string;
        InvoiceCompanyLogo1?: string;
        InvoiceCompanyLogo2?: string;
        InvoiceCompanyStampImage?: string;
        VendorName?: string;
        VendorDescription?: string;
        VendorBankName?: string;
        VendorBankAccountType?: number;
        VendorBankAccountName?: string;
        VendorBankAccountNo?: string;
        VendorBankIfscCode?: string;
        VendorAddress?: string;
        VendorCity?: string;
        VendorStateId?: number;
        VendorCountry?: string;
        VendorGstin?: string;
        VendorPan?: string;
        VendorGstCertificate?: string;
        VendorUserId?: number;
        VendorPincode?: number;
        VendorIsActive?: boolean;
        VendorInsertUserId?: number;
        VendorInsertDate?: string;
        VendorUpdateUserId?: number;
        VendorUpdateDate?: string;
        VendorEmail?: string;
        InsertUserId?: number;
        InsertDate?: string;
        UpdateUserId?: number;
        UpdateDate?: string;
    }

    export namespace OrdersRow {
        export const idProperty = 'Id';
        export const nameProperty = 'OrderNumber';
        export const localTextPrefix = 'Orders.Orders';
        export const lookupKey = 'Orders.Orders';

        export function getLookup(): Q.Lookup<OrdersRow> {
            return Q.getLookup<OrdersRow>('Orders.Orders');
        }
        export const deletePermission = 'Orders:OrdersManagement:Modify';
        export const insertPermission = 'Orders:OrdersManagement:Modify';
        export const readPermission = 'Orders:OrdersManagement:View';
        export const updatePermission = 'Orders:OrdersManagement:Modify';

        export declare const enum Fields {
            Id = "Id",
            CustomerId = "CustomerId",
            OrderNumber = "OrderNumber",
            CustomerName1 = "CustomerName1",
            CustomerEmail1 = "CustomerEmail1",
            CustomerEmail2 = "CustomerEmail2",
            CustomerMobile11 = "CustomerMobile11",
            CustomerMobile21 = "CustomerMobile21",
            BillingAddress1 = "BillingAddress1",
            BillingAddress2 = "BillingAddress2",
            BillingCity = "BillingCity",
            BillingCountry = "BillingCountry",
            BillingStateId = "BillingStateId",
            BillingPincode = "BillingPincode",
            ShippingToName = "ShippingToName",
            ShippingAddress1 = "ShippingAddress1",
            ShippingAddress2 = "ShippingAddress2",
            ShippingCity = "ShippingCity",
            ShippingCountry = "ShippingCountry",
            ShippingStateId = "ShippingStateId",
            ShippingPincode = "ShippingPincode",
            EOrderStatus = "EOrderStatus",
            EShippingType = "EShippingType",
            DiscountPer = "DiscountPer",
            CurrencyAmount = "CurrencyAmount",
            OrderDate = "OrderDate",
            ESourceType = "ESourceType",
            Mode = "Mode",
            Level = "Level",
            Note = "Note",
            CurrencyId = "CurrencyId",
            CalculationCurrency = "CalculationCurrency",
            SourceName = "SourceName",
            EmailSendCount = "EmailSendCount",
            IsEmailSent = "IsEmailSent",
            EPaymentStatus = "EPaymentStatus",
            LastEmailSentDate = "LastEmailSentDate",
            FranchiseeId = "FranchiseeId",
            EOrderProcessBy = "EOrderProcessBy",
            DiscountCoupon = "DiscountCoupon",
            DiscountAmount = "DiscountAmount",
            GrossAmount = "GrossAmount",
            NetAmount = "NetAmount",
            NetAmountAfterFrDiscount = "NetAmountAfterFrDiscount",
            TaxableAmount = "TaxableAmount",
            TaxAmount = "TaxAmount",
            EShippingStatus = "EShippingStatus",
            EInvoiceStatus = "EInvoiceStatus",
            MailId = "MailId",
            EPaymentType = "EPaymentType",
            Gstin = "Gstin",
            ExpectedShippingDate = "ExpectedShippingDate",
            EInvoiceTo = "EInvoiceTo",
            EFranchiseeDiscountType = "EFranchiseeDiscountType",
            EFranchiseeDiscount = "EFranchiseeDiscount",
            FranchiseeDiscountValue = "FranchiseeDiscountValue",
            FranchiseeDiscountAmount = "FranchiseeDiscountAmount",
            InvoiceCompanyId = "InvoiceCompanyId",
            ShippingNote = "ShippingNote",
            SourceOrderNumber = "SourceOrderNumber",
            IsActive = "IsActive",
            FreezeData = "FreezeData",
            VendorId = "VendorId",
            ShippingProviderId = "ShippingProviderId",
            ShippingProviderName = "ShippingProviderName",
            CustomerDisplayName = "CustomerDisplayName",
            CustomerIsActive = "CustomerIsActive",
            CustomerInsertUserId = "CustomerInsertUserId",
            CustomerInsertDate = "CustomerInsertDate",
            CustomerUpdateUserId = "CustomerUpdateUserId",
            CustomerUpdateDate = "CustomerUpdateDate",
            CustomerECustomerType = "CustomerECustomerType",
            CustomerGstin = "CustomerGstin",
            CustomerCouponCode = "CustomerCouponCode",
            OrderProducts = "OrderProducts",
            OrderInstallments = "OrderInstallments",
            WebsiteOrderProducts = "WebsiteOrderProducts",
            BillingStateName = "BillingStateName",
            BillingStateIsActive = "BillingStateIsActive",
            BillingStateInsertUserId = "BillingStateInsertUserId",
            BillingStateInsertDate = "BillingStateInsertDate",
            BillingStateUpdateUserId = "BillingStateUpdateUserId",
            BillingStateUpdateDate = "BillingStateUpdateDate",
            BillingStateIsHomeState = "BillingStateIsHomeState",
            ShippingStateName = "ShippingStateName",
            ShippingStateIsActive = "ShippingStateIsActive",
            ShippingStateInsertUserId = "ShippingStateInsertUserId",
            ShippingStateInsertDate = "ShippingStateInsertDate",
            ShippingStateUpdateUserId = "ShippingStateUpdateUserId",
            ShippingStateUpdateDate = "ShippingStateUpdateDate",
            ShippingStateIsHomeState = "ShippingStateIsHomeState",
            FranchiseeName = "FranchiseeName",
            FranchiseeDescription = "FranchiseeDescription",
            FranchiseeEmail = "FranchiseeEmail",
            FranchiseeAlternateEmail = "FranchiseeAlternateEmail",
            FranchiseeMobile = "FranchiseeMobile",
            FranchiseeAlternateMobile = "FranchiseeAlternateMobile",
            FranchiseeAddress = "FranchiseeAddress",
            FranchiseeCity = "FranchiseeCity",
            FranchiseeStateId = "FranchiseeStateId",
            FranchiseeUserId = "FranchiseeUserId",
            FranchiseeGstin = "FranchiseeGstin",
            FranchiseePan = "FranchiseePan",
            FranchiseeGstCertificate = "FranchiseeGstCertificate",
            FranchiseeBankName = "FranchiseeBankName",
            FranchiseeBankAccountType = "FranchiseeBankAccountType",
            FranchiseeBankAccountName = "FranchiseeBankAccountName",
            FranchiseeBankAccountNo = "FranchiseeBankAccountNo",
            FranchiseeBankIfscCode = "FranchiseeBankIfscCode",
            FranchiseePincode = "FranchiseePincode",
            FranchiseeIsActive = "FranchiseeIsActive",
            FranchiseeInsertUserId = "FranchiseeInsertUserId",
            FranchiseeInsertDate = "FranchiseeInsertDate",
            FranchiseeUpdateUserId = "FranchiseeUpdateUserId",
            FranchiseeUpdateDate = "FranchiseeUpdateDate",
            FranchiseeIsCustomer = "FranchiseeIsCustomer",
            FranchiseeCustomerId = "FranchiseeCustomerId",
            FranchiseeDiscountCoupon = "FranchiseeDiscountCoupon",
            FranchiseeIsPostPayAllowed = "FranchiseeIsPostPayAllowed",
            InvoiceCompanyName = "InvoiceCompanyName",
            InvoiceCompanyAddress = "InvoiceCompanyAddress",
            InvoiceCompanyGstIn = "InvoiceCompanyGstIn",
            InvoiceCompanyInvoiceCode = "InvoiceCompanyInvoiceCode",
            InvoiceCompanyIsTaxApplicable = "InvoiceCompanyIsTaxApplicable",
            InvoiceCompanyInvoiceChangeDate = "InvoiceCompanyInvoiceChangeDate",
            InvoiceCompanyIsDefault = "InvoiceCompanyIsDefault",
            InvoiceCompanyFooterNote = "InvoiceCompanyFooterNote",
            InvoiceCompanyLogo1 = "InvoiceCompanyLogo1",
            InvoiceCompanyLogo2 = "InvoiceCompanyLogo2",
            InvoiceCompanyStampImage = "InvoiceCompanyStampImage",
            VendorName = "VendorName",
            VendorDescription = "VendorDescription",
            VendorBankName = "VendorBankName",
            VendorBankAccountType = "VendorBankAccountType",
            VendorBankAccountName = "VendorBankAccountName",
            VendorBankAccountNo = "VendorBankAccountNo",
            VendorBankIfscCode = "VendorBankIfscCode",
            VendorAddress = "VendorAddress",
            VendorCity = "VendorCity",
            VendorStateId = "VendorStateId",
            VendorCountry = "VendorCountry",
            VendorGstin = "VendorGstin",
            VendorPan = "VendorPan",
            VendorGstCertificate = "VendorGstCertificate",
            VendorUserId = "VendorUserId",
            VendorPincode = "VendorPincode",
            VendorIsActive = "VendorIsActive",
            VendorInsertUserId = "VendorInsertUserId",
            VendorInsertDate = "VendorInsertDate",
            VendorUpdateUserId = "VendorUpdateUserId",
            VendorUpdateDate = "VendorUpdateDate",
            VendorEmail = "VendorEmail",
            InsertUserId = "InsertUserId",
            InsertDate = "InsertDate",
            UpdateUserId = "UpdateUserId",
            UpdateDate = "UpdateDate"
        }
    }
}
